import Icon from '@ant-design/icons';
import '@ant-design/icons';
import { FC } from 'react';
import Wrap from './styles';

type Props = {
  title: string;
  icon: any;
};

const HeaderListBill: FC<Props> = ({ title, icon, children }) => {
  return (
    <Wrap>
      <div className="title">
        <div>
          <Icon component={icon} className="icon-billing" />
          <p className="extraLargeFont inline">{title}</p>
        </div>
      </div>
      {children}
    </Wrap>
  );
};

export default HeaderListBill;
